module.exports = __webpack_public_path__ + "img/logo@2x.ab4212e0.png";